import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '../../config/constants';

/**
 * 获取字段列表
 */
export function getFieldsApi({ public_field } = { public_field: false }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field`,
        method: 'GET',
        params: {
            public_field
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取单个字段
 */
export function getFieldApi({ field_id, folder_id, need_count = true }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/${field_id}`,
        method: 'GET',
        params: {
            folder_id,
            need_count,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取字段创建数量余额
 */
export function getFieldLimitApi(folder_id, public_field = false) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/limit`,
        method: 'POST',
        data: {
            folder_id,
            public_field,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 创建字段
 */
export function createFieldApi({
    data_type = 'PATENT',
    view_type,
    folder_id,
    field_color,
    field_name,
    field_option_value,
    field_layer_value,
    field_type,
    to_index,
    sort,
    folder_data_source,
    word_cloud_snapshot,
    word_text_option_text,
    auto_edit_field_value,
    auto_edit_field_value_scope,
    field_usage,
    auto_field_label_rule_list,
    field_label_scope,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/field`,
        method: 'POST',
        data: {
            data_type,
            view_type,
            field_color,
            field_name,
            field_option_value,
            field_layer_value,
            field_type,
            to_index,
            sort,
            folder_data_source,
            word_cloud_snapshot,
            word_text_option_text,
            auto_edit_field_value,
            auto_edit_field_value_scope,
            field_usage,
            auto_field_label_rule_list,
            field_label_scope,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 编辑字段
 */
export function editFieldApi({
    view_type,
    folder_id,
    field_id,
    field_color,
    field_name,
    field_option_value,
    field_layer_value,
    field_type,
    folder_data_source,
    word_cloud_snapshot,
    word_text_option_text,
    auto_edit_field_value,
    auto_edit_field_value_scope,
    field_usage,
    auto_field_label_rule_list
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/field/${field_id}`,
        method: 'PUT',
        data: {
            view_type,
            field_color,
            field_name,
            field_option_value,
            field_layer_value,
            field_type,
            folder_data_source,
            word_cloud_snapshot,
            word_text_option_text,
            auto_edit_field_value,
            auto_edit_field_value_scope,
            field_usage,
            auto_field_label_rule_list
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 创建字段（非folder）
 */
export function createFieldGlobalApi({
    data_type = 'PATENT',
    field_color,
    field_name,
    field_option_value,
    field_layer_value,
    field_type,
    folder_data_source,
    word_cloud_snapshot,
    word_text_option_text,
    auto_edit_field_value,
    auto_edit_field_value_scope,
    field_usage,
    public_field,
    auto_field_label_rule_list,
    field_label_scope,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field`,
        method: 'POST',
        data: {
            data_type,
            field_color,
            field_name,
            field_option_value,
            field_layer_value,
            field_type,
            folder_data_source,
            word_cloud_snapshot,
            word_text_option_text,
            auto_edit_field_value,
            auto_edit_field_value_scope,
            field_usage,
            public_field,
            auto_field_label_rule_list,
            field_label_scope,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 编辑字段（非folder）
 */
export function editFieldGlobalApi({
    field_id,
    field_color,
    field_name,
    field_option_value,
    field_layer_value,
    field_type,
    folder_data_source,
    word_cloud_snapshot,
    word_text_option_text,
    auto_edit_field_value,
    auto_edit_field_value_scope,
    field_usage,
    auto_field_label_rule_list,
    field_label_scope,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/${field_id}`,
        method: 'PUT',
        data: {
            field_color,
            field_name,
            field_option_value,
            field_layer_value,
            field_type,
            folder_data_source,
            word_cloud_snapshot,
            word_text_option_text,
            auto_edit_field_value,
            auto_edit_field_value_scope,
            field_usage,
            auto_field_label_rule_list,
            field_label_scope,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 批量删除字段
 */
export function batchDeleteFieldApi(ids = [], public_field) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field`,
        params: {
            public_field,
        },
        method: 'DELETE',
        data: ids,
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 保存字段排序
 * @param {*} current_sort 当前排序
 * @param {*} custom_field_sort 自定义字段排序的顺序
 */
export function saveFieldSortApi(current_sort, custom_field_sort, public_field) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/sort`,
        method: 'POST',
        data: {
            current_sort,
            custom_field_sort,
            public_field,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 删除字段
 */
export function deleteFieldApi({ folder_id, field_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/field/${field_id}`,
        method: 'DELETE',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 更新字段显示/隐藏设置
 */
export function updateFieldSettingApi({ folder_id, custom_fields }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/setting-field`,
        method: 'POST',
        data: {
            custom_fields
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 编辑单个自定义字段
 */
export function saveCustomFieldValueApi({ folder_id, data_id, field_id, field_value, data_type = 'PATENT', ai_field_id, ignore_family_edit }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/single/field-value`,
        method: 'POST',
        data: {
            folder_id,
            field_id,
            data_id,
            field_value,
            data_type,
            ai_field_id,
            ignore_family_edit,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 拖拽自定义字段赋值
 */
export function dragSaveCustomFieldValueApi({ space_id, folder_id, cells }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/drag-field-value`,
        method: 'POST',
        data: {
            space_id,
            folder_id,
            cells
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取层级树
 */
export function getLayersApi({ space_id, folder_id, field_id, need_tree, need_count, qid, efqid, ai_field_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/query-layers`,
        method: 'POST',
        data: {
            space_id,
            folder_id,
            field_id,
            need_tree,
            need_count,
            qid,
            efqid,
            ai_field_id
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || [];
    });
}

/**
 * 获取字段状态
 */
export function getFieldStatusApi({
    folder_id,
    field_status_updates,
    patent_ids,
    refiner,
    select_mode,
    range_from,
    range_to,
    sort,
    doc_ids,
    data_type = 'PATENT',
    ai_field_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/field-status`,
        method: 'POST',
        data: {
            field_status_updates,
            patent_ids,
            refiner,
            select_mode,
            start: range_from,
            end: range_to,
            sort,
            doc_ids,
            data_type,
            ai_field_id,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 批量更新字段
 */
export function batchSaveFieldApi({
    folder_id,
    field_update_values,
    patent_ids,
    refiner,
    select_mode,
    space_id,
    current_page_patent_ids,
    range_from,
    range_to,
    sort,
    data_type = 'PATENT',
    current_page_doc_ids,
    doc_ids,
    ai_field_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/batch-save-field-values`,
        method: 'POST',
        data: {
            field_update_values,
            patent_ids,
            refiner,
            select_mode,
            space_id,
            current_page_patent_ids,
            start: range_from,
            end: range_to,
            sort,
            data_type,
            current_page_doc_ids,
            doc_ids,
            ai_field_id,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 为选项型自定义字段添加选项
 */
export function addOptionForOptionCustomField({ folder_id, field_id, option_text }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/field/${field_id}/option`,
        method: 'POST',
        data: {
            option_text
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 更新选项型自定义字段的选项名
 */
export function updateOptionTextForOptionCustomField({ folder_id, field_id, option_id, option_text }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/field/${field_id}/option/${option_id}`,
        method: 'PUT',
        data: {
            option_text
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 更新自定义字段的排序
 */
export function updateCustomFieldSortApi(field_id, folder_id, is_pin) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field-display-setting`,
        method: 'POST',
        data: {
            folder_id,
            field_id,
            is_pin
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 分享自定义字段邮箱检查
 */
export function checkCustomFieldEmail({ email, layerCount, otherFieldCount, identifier, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/email/check-custom-field-role`,
        method: 'get',
        params: {
            email,
            layer_field_count: layerCount,
            plain_field_count: otherFieldCount,
            identifier,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 分享自定义字段
 */
export function shareCustomFields({ user_ids = [], fields = [], groups = [], }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/share`,
        method: 'post',
        data: {
            user_ids,
            field_list: fields,
            groups
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 复制为公共自定义字段
 */
export function copyCustomFieldsApi(fields = []) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/to-public`,
        method: 'post',
        data: {
            field_list: fields,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}


export function wordCloudApi({ folderIds, scope }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/word-cloud/cluster`,
        method: 'post',
        data: {
            folder_data_source: folderIds,
            patent_scope: scope
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 转换自定义字段
 */
export function transformCustomFieldApi({
    space_id,
    folder_id,
    source_field_id,
    target_field_id,
    all,
    range,
    layer_node_list,
    qid,
    efqid,
    sort,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/transform`,
        method: 'POST',
        data: {
            space_id,
            folder_id,
            source_field_id,
            target_field_id,
            all,
            range,
            layer_node_list,
            qid,
            efqid,
            sort,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function finishTransformCustomFieldApi({ folder_id, task_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/transform-finish`,
        method: 'POST',
        params: {
            folder_id,
            task_id,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 自动标引
 */
export function autoLabelCustomField({
    auto_label_field_id,
    auto_edit_field_value_scope,
    auto_field_label_rule_list,
    efqid,
    end,
    start,
    folder_id,
    patent_ids,
    refiner,
    qid,
    sort,
    select_mode,
    field_name,
    field_type,
    field_color,
    view_type,
    field_layer_value,
    field_option_value,
    field_usage,
    folder_data_source,
    word_cloud_snapshot,
    word_text_option_text,
    auto_edit_field_value,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/auto-label`,
        method: 'POST',
        data: {
            auto_label_field_id,
            auto_edit_field_value_scope,
            auto_field_label_rule_list,
            end,
            start,
            efqid,
            folder_id,
            patent_ids,
            refiner,
            qid,
            sort,
            select_mode,
            field_name,
            field_type,
            field_color,
            view_type,
            field_layer_value,
            field_option_value,
            field_usage,
            folder_data_source,
            word_cloud_snapshot,
            word_text_option_text,
            auto_edit_field_value,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 自定义字段导入
 */
export function importCustomField({ field_id, folder_id, field_type, file_name, poster, field_layer_value, field_option_value }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/import/field`,
        method: 'POST',
        params: {
            field_id,
            folder_id,
        },
        data: {
            field_type,
            file_name,
            poster,
            field_layer_value,
            field_option_value
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/* srp -> view右侧列表获取自定义字段 */
export function getCustomFieldValue(patent_id) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/patent/view/owner/field-value`,
        method: 'GET',
        params: {
            patent_id,
        },
        transformCode: true
    });
}

/* view右侧列表保存自定义字段值 */
export function saveCustomFieldValue({
    field_id,
    field_value,
    folder_id,
    patent_id,
    data_type = 'PATENT',
    ignore_family_edit,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/single/field-value`,
        method: 'POST',
        data: {
            field_id,
            field_value,
            folder_id,
            data_id: patent_id,
            data_type,
            ignore_family_edit
        },
        transformCode: true
    });
}

/* view右侧列表创建自定义字段 */
export function createCustomFieldValue({
    field_name,
    field_color,
    field_type,
    folder_id,
    space_id,
    field_option_value,
    field_layer_value
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/patent/view/field`,
        method: 'POST',
        data: {
            field_name,
            field_color,
            field_type,
            folder_id,
            space_id,
            field_option_value,
            field_layer_value
        },
        transformCode: true
    });
}

// LAB image comments preview
export function imageCommentsPreviewApi({
    image_key_list
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/image/image-comment/preview`,
        method: 'POST',
        data: {
            image_key_list
        },
        transformCode: true
    });
}
/**
 * AI确认接口
 * @param {*} param0
 * @returns
 */
export function confirmAiFieldApi({
    folder_id,
    patent_ids = [],
    refiner = {},
    select_mode,
    range_from,
    range_to,
    sort,
    ai_field_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/smart/folder/${folder_id}/field/${ai_field_id}/check-patent`,
        method: 'POST',
        data: {
            patent_ids,
            refiner,
            select_mode,
            start: range_from,
            end: range_to,
            sort,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取公司自定义字段
 */
export function getCompanyFieldsApi({ field_type = 'company', cache = true } = { field_type: 'company', cache: true }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/web-search`,
        method: 'GET',
        params: {
            field_type
        },
        cache,
        transformCode: true
    }).then(({ data }) => {
        return data.data || [];
    });
}

/**
 * 获取一批专利的自定义字段值
 * @param patents
 * @param fields
 */
export function getPatentsCustomFieldValue({ patents, fields = [], spaceType = 'company', cache = false, space_id}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/patents/custom-field-value`,
        method: 'POST',
        data: {
            patent_ids: patents,
            field_ids: fields,
            space_type: spaceType,
            space_id: space_id,
        },
        cache,
    }).then(({ data }) => {
        return data.data || {};
    });
}
